import WForever from './WForever'

export default WForever
